module.exports = __webpack_public_path__ + "img/5fab087.jpg";